import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRockedCurriculumTenures, showProgress } from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import ZeroState from '../common/ZeroState';
import FileIcon from '../../assets/FileIcon';
import Modal from '../common/Modal';
import ShowProgress from '../ui/Backdrop';
import ReactDnD from '../common/ReactDnD';
import CollectionCard, { AllCollectionsList, MenuItems } from './CollectionCard';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  jouneyHeading: {
    width: '100%',
    height: '50px',
    background: '#f3f4f7',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 10px',
  },
  addCollection: {
    width: '40px',
    height: '40px',
    color: 'white',
    background: '#622FEE',
    border: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer',
  },
  collectionList: {
    margin: '20px 0px',
    width: '100%',
    height: '500px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
}));

export default function CurriculumCollections() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const roleDetails = useSelector((state) => state.rockedCurriculumData.selectedRole);
  const tenureSelected = useSelector((state) => state.rockedCurriculumData.selectedTenure);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [collections, setCollections] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [availableCollections, setAvailableCollection] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const handleUpdateCollection = async (collectionIds) => {
    dispatch(showProgress(true));
    try {
      await Service.post(apiEndpoints.RC_COLLECTIONS.replace('ID', tenureSelected?.id), {
        collectionIds,
      });

      getCollection();
      handleUpdateTenures();

      notifySuccess('Collection updated successfully');
      setIsOpenModal(false);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getAddCollectionList = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.RC_COLLECTIONS_LIST.replace('ID', roleDetails.id));
      setCollections(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleAddBtn = () => {
    setIsOpenModal(true);
    getAddCollectionList();
  };

  const handleSelectCollection = (id) => {
    if (selectedCollections.includes(id)) {
      setSelectedCollections((prevSelectedCollections) =>
        prevSelectedCollections.filter((collectionId) => collectionId !== id),
      );
    } else {
      setSelectedCollections((prevSelectedCollections) => [...prevSelectedCollections, id]);
    }
  };

  const handleUpdateTenures = async () => {
    try {
      const res = await Service.get(apiEndpoints.RC_YOE.replace('ID', roleDetails.id));
      dispatch(setRockedCurriculumTenures(res));
    } catch (error) {
      ErrorToast(error);
    }
  };

  const getCollection = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.RC_SELECTED_COLLECTONS.replace('ID', tenureSelected?.id));
      setAvailableCollection(res);
      const temp = res.map((data) => data.id);
      setSelectedCollections(temp);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  }, [tenureSelected, dispatch]);

  useEffect(() => {
    if (tenureSelected?.id) {
      getCollection();
    }
  }, [tenureSelected, getCollection]);

  const handleDeleteCollection = () => {
    const temp = availableCollections.filter((data) => data.id !== selectedId).map((data) => data.id);
    handleUpdateCollection(temp);
    setAnchorEl(null);
  };

  return (
    <Grid container style={{ marginLeft: '50px' }}>
      <Grid className={classes.jouneyHeading}>
        <Typography variant="h6">Collections</Typography>
        <Grid className={classes.addCollection} onClick={handleAddBtn}>
          <Add />
        </Grid>
      </Grid>

      {availableCollections.length > 0 ? (
        <>
          <ReactDnD
            data={availableCollections}
            setData={setAvailableCollection}
            setModifiedOrderIds={handleUpdateCollection}
            renderItem={(collectionData) => (
              <CollectionCard collectionData={collectionData} setAnchorEl={setAnchorEl} setSelectedId={setSelectedId} />
            )}
          />
          <MenuItems anchorEl={anchorEl} setAnchorEl={setAnchorEl} onDelete={handleDeleteCollection} />
        </>
      ) : (
        <Grid className={classes.collectionList}>
          <Grid item>
            <ZeroState
              Icon={FileIcon}
              title="No collection added for this specific role and tenure"
              text="Add collections to curate the RockED Curriculum for this Role and Tenure"
              style={{ paddingBottom: '100px', marginTop: '40px' }}
              cardWidth="36vw"
            />
          </Grid>
        </Grid>
      )}

      <Modal isOpen={isOpenModal} height="700px" width="700px">
        <AllCollectionsList
          filteredCollections={filteredCollections}
          setFilteredCollections={setFilteredCollections}
          collections={collections}
          handleSelectCollection={handleSelectCollection}
          selectedCollections={selectedCollections}
          setSelectedCollections={setSelectedCollections}
          handleUpdateCollection={handleUpdateCollection}
          setIsOpenModal={setIsOpenModal}
        />
      </Modal>
      <ShowProgress />
    </Grid>
  );
}
